<template>
    <app-layout :title="$t('File Storage')">
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                {{ $t('File Storage') }}
            </h2>
        </template>


        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <page-heading :breadcrumbs="breadcrumbs" class="px-4 sm:px-0">
                <template #title>
                    {{ customer.name }}
                </template>
                <template #actionButtons>

                </template>
            </page-heading>
            <hr class="my-5">
            <FileContainerContainer :containers="containers" :active-container="activeContainer"/>
        </div>
    </app-layout>
</template>

<script>
import {defineComponent} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import FileContainerContainer from '@/Components/FileContainerContainer.vue'
import PageHeading from "@/Components/PageHeading";

export default defineComponent({
    components: {
        AppLayout,
        FileContainerContainer,
        PageHeading,
    },

    props: {
        containers: Object,
        customer: Object,
        activeContainer: Object,
    },
    data() {
        return {
            breadcrumbs: [
                {
                    label: 'Customers',
                    url: route('consultant-customers.index'),
                },
                {
                    label: this.customer.name,
                    url: route('consultant-customers.show', {customer: this.customer.id}),
                }
            ]
        }
    }
})
</script>
